/*
 * In order to provide semantic meaning and safer usage of model-effects,
 *  these hooks allow using the loading and error state of mutable hooks,
 *  but with appropriate encapsulation.
 *
 * NOTE: The implementation in this file depends wholly on `mutable.ts`.
 */

import { DependencyList } from 'react'

import { AsyncEffectHandle } from './async-effect'
import { useMutableObject, useMutableList } from './mutable'

/**
 * Similar to useMutableObject, however this hook does not allow changing the object-state.
 */
export const useImmutableObject = <T>(
    effect: () => Promise<T | null>,
    deps: DependencyList
): [T | undefined, ...AsyncEffectHandle] => {
    const [data, loading, error, refresh] = useMutableObject(effect, deps)
    return [data, loading, error, refresh]
}

/**
 * Similar to useMutableList, however this hook does not allow changing the list.
 */
export const useImmutableList = <T>(
    effect: () => Promise<T[] | null>,
    deps: DependencyList
): [T[], ...AsyncEffectHandle] => {
    const [data, loading, error, refresh] = useMutableList(effect, deps)
    return [data, loading, error, refresh]
}
